import React, { useEffect, useState } from "react";
import { imgUrl } from "../lib/api";

/* Video-like banner: AI frames crossfade with Ken Burns zoom + gold sparkle particles. Loops while the slide is visible. */
export function StoryBanner({ banner, active, onFrame }) {
  const frames = banner.frames || [];
  const per = Math.max(1500, Math.round((banner.duration_ms || 12000) / Math.max(frames.length, 1)));
  const [f, setF] = useState(0);
  useEffect(() => { onFrame?.(f); }, [f, onFrame]);
  useEffect(() => {
    if (!active) { setF(0); return; }
    const t = setInterval(() => setF((x) => (x + 1) % frames.length), per);
    return () => clearInterval(t);
  }, [active, per, frames.length]);
  const sparks = React.useMemo(() => Array.from({ length: 18 }, (_, i) => ({ l: (i * 53) % 100, d: (i % 6) * 0.7, s: 0.6 + (i % 4) * 0.25, t: 2.6 + (i % 5) * 0.6 })), []);
  return (
    <div className="absolute inset-0 overflow-hidden" data-testid={`story-banner-${banner.id}`}>
      {frames.map((src, i) => (
        <img key={src} src={imgUrl(src)} alt="" className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-[1200ms] ease-in-out ${i === f ? "opacity-100" : "opacity-0"}`}
          style={{ animation: i === f && active ? `rl-kenburns ${per + 1400}ms ease-out forwards` : "none" }} />
      ))}
      <div className="absolute inset-0 pointer-events-none">
        {sparks.map((s, i) => <span key={i} className="rl-spark" style={{ left: `${s.l}%`, animationDelay: `${s.d}s`, animationDuration: `${s.t}s`, transform: `scale(${s.s})` }} />)}
      </div>
      <div className="absolute inset-0 rl-shine-sweep pointer-events-none" />
      <div className="absolute bottom-2 right-2 flex gap-1">{frames.map((_, i) => <span key={i} className={`h-1 rounded-full transition-all ${i === f ? "w-4 bg-amber-300" : "w-1 bg-white/40"}`} />)}</div>
    </div>
  );
}
